import * as React from "react";

import Constants, { LegalViewStatus } from "../../common/Constants";
import {
  Col,
  Row,
  Form,
  Checkbox,
  Input,
  Select,
  Card,
  Space,
  Button
} from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { TLegalViewPresentationModel } from "../../presenter/model/LegalViewPresentationModel";
import { IOrganisationIndex } from "../../../organisations/model/OrganisationIndex";
import AttachmentTable from "../../../caseLawDocuments/ui/components/AttachmentTable";
import { TAttachmentTypePresentationModel } from "../../../organisations/presenter/model/AttachmentTypePresentationModel";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { TAttachmentPresentationModel } from "../../../caseLawDocuments/presenter/model/AttachmentPresentationModel";
import { IStore } from "../../../core/model/runtime/state/Store";
import TranslationTextAreaField from "../../../core/ui/components/TranslationTextAreaField";
import { TDocumentTypeIndexCategoryPresentationModel } from "../../../documentTypes/presenter/DocumentTypeIndexCategoryPresentationModel";
import FormSection from "../../../core/ui/components/FormSection";
import SelectInput from "../../../core/ui/components/SelectInput";
import { TOrganisationIndexGroupPresentationModel } from "../../../organisations/presenter/model/OrganisationIndexGroupPresentationModel";
import DateTimePicker from "../../../core/ui/components/DateTimePicker";
import moment from "moment";
import { DateFormats } from "../../../core/common/Constants";
import { IIndexTypeAttribute } from "../../../indexTypes/model/IndexTypeAttribute";
import { IIndexAttributeData } from "../../../indexTypes/model/IndexAttributeData";
import IndexAttributeDataForm from "../../../caseLawDocuments/ui/components/IndexAttributeDataForm";

const FormFields = {
  ID: "id",
  SUMMARY: "summary",
  STATUS: "status",
  DOCUMENT_TYPE_ID: "documentTypeId",
  ORGANISATION_ID: "organisationId",
  DATE: "legalViewDate",
  VALID: "valid",
  ORGANISATION_INDEX_LIST: "organisationIndexList",
  PARENT_GROUP: "parentGroup",
  SECOND_GROUP: "secondGroup"
};

const LegalViewUpdateForm = ({
  translate,
  legalView,
  legalViewTypes,
  organisationIndexes,
  selectedIndex,
  onSubmit,
  showLegalViewDetails,
  legalViewTypeId,
  attachmentTypes,
  attachments,
  attachmentContentTypes,
  createAttachment,
  setAttachmentType,
  uploadedFile,
  setFileValue,
  updateAttachment,
  store,
  selectedOrganisationId,
  canEdit,
  selectedParentGroupIdList,
  selectedSecondGroupIdList,
  parentGroupList,
  secondGroupList,
  setParentGroupId,
  setSecondGroupId,
  selectedIndexes,
  anonimisedUploadedFile,
  setAnonymisedFileValue,
  removeAttachment,
  indexTypeAttributes,
  setAttributesData,
  indexAttributeDataList,
  closeIndexDataModal,
  openIndexDataModal,
  indexDataModalVisible,
  saveAttributeData,
  selectedIndexForAttribute
}: {
  legalView: TLegalViewPresentationModel;
  translate;
  legalViewTypes;
  organisations;
  setOrganisationId;
  organisationIndexes: TDocumentTypeIndexCategoryPresentationModel[];
  selectedIndex: IOrganisationIndex[][];
  onSubmit;
  showLegalViewDetails;
  legalViewTypeId;
  attachmentTypes: TAttachmentTypePresentationModel[];
  attachmentContentTypes: IGenericCodebookItem[];
  attachments: TAttachmentPresentationModel[];
  attachmentType: string;
  createAttachment: any;
  getAttachments: any;
  setAttachmentType: any;
  uploadedFile: any;
  setFileValue: any;
  updateAttachment: any;
  store: IStore;
  selectedOrganisationId?: number;
  canEdit: any;
  selectedParentGroupIdList: number[];
  selectedSecondGroupIdList: number[];
  parentGroupList: TOrganisationIndexGroupPresentationModel[][];
  secondGroupList: TOrganisationIndexGroupPresentationModel[][];
  setParentGroupId: (selectedParentGroupId: number, index: number) => void;
  setSecondGroupId: (selectedSecondGroupId: number, index: number) => void;
  selectedIndexes?: any;
  anonimisedUploadedFile: any;
  setAnonymisedFileValue: any;
  removeAttachment: any;
  indexTypeAttributes?: IIndexTypeAttribute[];
  setAttributesData?: any;
  indexAttributeDataList?: IIndexAttributeData[];
  closeIndexDataModal: any;
  openIndexDataModal: any;
  indexDataModalVisible: boolean;
  saveAttributeData: any;
  selectedIndexForAttribute: any;
}) => {
  const [form] = Form.useForm();
  const { Option } = Select;

  const getInitialValues = (rowData, store: IStore) => {
    if (rowData && Object.keys(rowData).length > 0) {
      if (rowData.summaryTranslations.length > 0) {
        return rowData.summaryTranslations;
      } else {
        return [
          {
            summaryTranslation: rowData.name,
            languageId: store.getState<any>().selectedLanguage.id,
            valid: true
          }
        ];
      }
    } else {
      return [
        {
          summaryTranslation: "",
          languageId: store.getState<any>().selectedLanguage.id,
          valid: true
        }
      ];
    }
  };

  function onChangeParentGroup(value, index) {
    const values = form.getFieldsValue();
    values.secondGroup[index] = undefined;
    values.organisationIndexList[index] = undefined;
    form.setFieldsValue({
      secondGroup: values.secondGroup,
      organisationIndexList: values.organisationIndexList
    });

    setParentGroupId(value, index);
    setSecondGroupId(NaN, index);
  }

  function onChangeSecondGroup(value, index) {
    const selectedParentGroupId = selectedParentGroupIdList[index];
    setSecondGroupId(value, index);
    const values = form.getFieldsValue();
    if (isNaN(selectedParentGroupId)) {
      setParentGroupId(
        secondGroupList[index].find((elem) => elem.id === value)?.parentId ??
          NaN,
        index
      );
    }
    values.parentGroup[index] =
      secondGroupList[index].find((elem) => elem.id === value)?.parentId ?? NaN;
    values.organisationIndexList[index] = undefined;
    form.setFieldsValue({
      parentGroup: values.parentGroup,
      organisationIndexList: values.organisationIndexList
    });
  }

  function filterSecondGroupValues(index) {
    const selectedParentGroupId = selectedParentGroupIdList[index];
    let newList = selectedParentGroupId
      ? secondGroupList[index].filter(
          (elem) => elem.parentId === selectedParentGroupId
        )
      : secondGroupList[index];

    return newList;
  }
  function findParent(group, groupList, data) {
    if (group?.parentId) {
      let g = groupList.find((g) => g.id === group?.parentId);
      if (g) {
        data = data + ` 🡐 ${g?.name}`;
        return findParent(g, groupList, data);
      }
    } else if (group?.organisationIndexCategory) {
      data = data + ` 🡐 ${group?.organisationIndexCategory?.name}`;
    }
    return data;
  }

  function renderOptions(list) {
    return list.map((index) => {
      let data = index.name;
      if (index.groups) {
        let firstGroup = index.groups.find(
          (g) => g.id === index.organisationGroupId
        );
        data = `${index?.name} 🡐 ${firstGroup?.name}`;
        data = findParent(firstGroup, index.groups, data);
      }
      return (
        <Option key={index.id} value={index.id} title={data} label={data}>
          {data}
        </Option>
      );
    });
  }

  function filterIndexData(list, index) {
    const selectedParentGroupId = selectedParentGroupIdList[index];
    let newList = list;
    if (selectedParentGroupId) {
      newList = list.filter(
        (item) =>
          item.groups.findIndex(
            (element) => element.id === selectedParentGroupId
          ) !== -1
      );
    }

    return newList;
  }

  legalView &&
    form.setFieldsValue({
      legalViewTypeId: legalView.documentTypeId ?? legalViewTypeId,
      documentTypeId: legalView.documentTypeId,
      organisationId: legalView.organisationId,
      summary: legalView.summary,
      summaryTranslations: getInitialValues(legalView, store),
      id: legalView.id,
      valid: legalView.valid,
      status: legalView.status,
      legalViewDate: legalView.legalViewDate
        ? moment(legalView.legalViewDate)
        : null
    });
  return (
    <Form layout={"vertical"} form={form}>
      <Row align="middle" justify="center">
        <Col xl={20} lg={24} md={24} sm={24} xs={24}>
          <Card bordered={false}>
            <Form.Item
              name={FormFields.ID}
              initialValue={legalView?.id}
              style={{ display: "none" }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={FormFields.VALID}
              valuePropName={"checked"}
              initialValue={legalView.valid ?? true}
              style={{ display: "none" }}
            >
              <Checkbox />
            </Form.Item>
            <Form.Item
              style={{ display: "none" }}
              name={FormFields.STATUS}
              initialValue={legalView?.status ?? LegalViewStatus.IN_PROGRESS}
            >
              <Input />
            </Form.Item>
            <Form.Item
              style={{ display: "none" }}
              name={FormFields.ORGANISATION_ID}
              initialValue={legalView?.organisationId}
            >
              <Input />
            </Form.Item>
            <Form.Item
              style={{ display: "none" }}
              name={FormFields.DOCUMENT_TYPE_ID}
              initialValue={legalView?.documentTypeId}
            >
              <Input />
            </Form.Item>

            <Space direction="vertical" style={{ width: "100%" }}>
              <FormSection
                title={translate("editors.legal_views.basic_data")}
                subtitle={translate("editors.legal_views.basic_data")}
              >
                <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col xs={24} sm={24}>
                    <div>
                      <Form.Item
                        label={translate(
                          "editors.legal_views.fields.legal_view_type"
                        )}
                        name={FormFields.DOCUMENT_TYPE_ID}
                        initialValue={legalView.documentTypeId}
                        className={"mb-0"}
                        rules={[
                          {
                            required: true,
                            message: translate(
                              "editors.legal_views.required_messages",
                              {
                                field: translate(
                                  "editors.legal_views.fields.legal_view_type"
                                )
                              }
                            )
                          }
                        ]}
                      >
                        <SelectInput
                          disabled={
                            form.getFieldValue("organisationId") === undefined
                          }
                          placeholder={translate(
                            "editors.legal_views.fields.select_legal_view_type"
                          )}
                          allowClear
                          showSearch={true}
                          notFoundContent={translate("search.no_data")}
                          selectOptionKey={"id"}
                          selectOptionValue={"name"}
                          selectOptions={legalViewTypes}
                        />
                      </Form.Item>
                    </div>
                    <Form.Item
                      label={translate("editors.legal_views.date")}
                      name={FormFields.DATE}
                      rules={[
                        {
                          required: true,
                          message: translate(
                            "editors.case_law_documents.required_messages",
                            {
                              field: translate(
                                "editors.case_law_documents.date"
                              )
                            }
                          )
                        }
                      ]}
                    >
                      <DateTimePicker
                        placeholder={translate("date_picker.placeholder")}
                        format={DateFormats.DATE}
                        showToday={true}
                        className={"input-date-wrapper"}
                        translate={translate}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col xs={24} sm={24}>
                    <div style={{ marginTop: "3em" }}>
                      <TranslationTextAreaField
                        translate={translate}
                        organisationId={selectedOrganisationId}
                        translationObjectIdFieldName={"legalViewId"}
                        store={store}
                        form={form}
                        rowData={legalView}
                        label={translate("editors.legal_views.fields.summary")}
                        noteLabel={translate("editors.legal_views.fields.note")}
                      />
                    </div>
                  </Col>
                </Row>
              </FormSection>
              {organisationIndexes?.length > 0 && (
                <FormSection
                  title={translate("editors.legal_views.fields.classification")}
                  subtitle={translate(
                    "editors.legal_views.fields.index_selection"
                  )}
                >
                  {organisationIndexes.map((item, index) => {
                    return (
                      <>
                        <Row
                          style={
                            organisationIndexes.length === 0
                              ? { display: "none" }
                              : {
                                  marginTop: 10,
                                  alignItems: "center"
                                }
                          }
                        >
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            style={{
                              display: "none",
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          >
                            <Form.Item
                              label={translate(
                                "editors.case_law_documents.parent_group"
                              )}
                              className={"mb-0"}
                              style={{
                                width: "100%",
                                marginRight: 10
                              }}
                              name={[FormFields.PARENT_GROUP, index]}
                              initialValue={selectedParentGroupIdList[index]}
                              dependencies={[`secondGroup[${index}]`]}
                            >
                              <SelectInput
                                placeholder={translate(
                                  "editors.case_law_documents.select_parent_group"
                                )}
                                allowClear
                                showSearch={true}
                                notFoundContent={translate("search.no_data")}
                                selectOptionKey={"id"}
                                selectOptionValue={"name"}
                                selectOptions={parentGroupList[index]}
                                onChange={(value) => {
                                  onChangeParentGroup(value, index);
                                }}
                              />
                            </Form.Item>
                          </Col>

                          <Col
                            span={7}
                            style={{
                              display: "none",
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          >
                            <Form.Item
                              label={translate(
                                "editors.case_law_documents.second_group"
                              )}
                              className={"mb-0"}
                              style={{
                                width: "100%",
                                marginRight: 10
                              }}
                              initialValue={selectedSecondGroupIdList[index]}
                              name={[FormFields.SECOND_GROUP, index]}
                              shouldUpdate
                            >
                              <SelectInput
                                allowClear
                                placeholder={translate(
                                  "editors.case_law_documents.select_second_group"
                                )}
                                showSearch={true}
                                notFoundContent={translate("search.no_data")}
                                selectOptionKey={"id"}
                                selectOptionValue={"name"}
                                selectOptions={filterSecondGroupValues(index)}
                                onChange={(value) =>
                                  onChangeSecondGroup(value, index)
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            style={{
                              marginTop: 20,
                              alignItems: "center"
                            }}
                          >
                            <Form.Item
                              name={[FormFields.ORGANISATION_INDEX_LIST, index]}
                              className={"mb-0"}
                              shouldUpdate
                              label={translate(
                                "editors.case_decisions.index_data"
                              )}
                              rules={[
                                {
                                  required: item.required,
                                  message: translate(
                                    "editors.case_decisions.required_messages",
                                    {
                                      field: translate(
                                        "editors.case_decisions.case_decision_type"
                                      )
                                    }
                                  )
                                },
                                {
                                  validator: (rule, value, callback) => {
                                    if (value && item.maxLength) {
                                      if (value.length > item.maxLength) {
                                        callback(
                                          `${translate(
                                            "editors.case_law_documents.index.max_length"
                                          )} ${item.maxLength}`
                                        );
                                      } else if (
                                        value.length <= item.maxLength
                                      ) {
                                        callback();
                                      }
                                    } else {
                                      callback();
                                    }

                                    return;
                                  }
                                }
                              ]}
                              initialValue={selectedIndex[index]?.map(
                                (item) => item.id
                              )}
                            >
                              <Select
                                placeholder={translate(
                                  "editors.case_law_documents.select_index_data"
                                )}
                                mode="multiple"
                                showSearch
                                optionFilterProp="children"
                                className={"png-tagbox"}
                              >
                                {renderOptions(
                                  filterIndexData(
                                    item.organisationIndexList,
                                    index
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    );
                  })}
                </FormSection>
              )}
            </Space>
          </Card>
        </Col>
      </Row>
      <Row justify="center">
        <Col
          lg={20}
          md={24}
          sm={24}
          xs={24}
          style={{ textAlign: "right", paddingTop: 20 }}
        >
          <Button
            value=""
            type="link"
            danger
            onClick={() => {
              form.resetFields();
              showLegalViewDetails(legalView.id);
            }}
          >
            <CloseOutlined /> {translate("data_grid.modal.actions.cancel")}
          </Button>
          <Button
            value=""
            type={"primary"}
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  onSubmit(values);
                })
                .catch((info) => {});
            }}
          >
            <CheckOutlined /> {translate("data_grid.modal.actions.save")}
          </Button>
        </Col>
      </Row>
      <IndexAttributeDataForm
        closeIndexDataModal={closeIndexDataModal}
        indexAttributeDataList={indexAttributeDataList}
        indexDataModalVisible={indexDataModalVisible}
        indexTypeAttributes={indexTypeAttributes}
        saveAttributeData={saveAttributeData}
        form={form}
        setAttributesData={setAttributesData}
        translate={translate}
        selectedIndexForAttribute={selectedIndexForAttribute}
      />
      <Row align="middle" justify="center" style={{ marginTop: 80 }}>
        <Col xl={20} lg={24} md={24} sm={24} xs={24}>
          <Card>
            <FormSection
              title={translate("editors.legal_views.attachments")}
              subtitle={translate("editors.legal_views.attachments")}
            >
              <AttachmentTable
                translate={translate}
                attachmentTypes={attachmentTypes}
                attachments={attachments}
                createAttachment={createAttachment}
                setFileValue={setFileValue}
                uploadedFile={uploadedFile}
                editable={true}
                updateAttachment={updateAttachment}
                setAttachmentType={setAttachmentType}
                deleteAttachment={removeAttachment}
                contentTypes={attachmentContentTypes}
                item={legalView}
                organisationId={legalView.organisationId}
                basePath={Constants.endpointBasePath}
                canDownload={canEdit}
                anonimisedUploadedFile={anonimisedUploadedFile}
                setAnonymisedFileValue={setAnonymisedFileValue}
              />
            </FormSection>
          </Card>
        </Col>
      </Row>
    </Form>
  );
};
export default LegalViewUpdateForm;
